import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';

function fmtDate(s) { return s ? new Date(s.replace(' ', 'T') + 'Z').toLocaleString('ko-KR') : '-'; }

export default function PostsPage({ kind, title }) {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.listPosts(kind).then(setPosts); }, [kind]);

  return (
    <div className="max-w-5xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-medical-800">{title}</h1>
        <Link to={'/' + kind + '/new'} className="bg-medical-600 hover:bg-medical-700 text-white text-sm font-semibold px-3 py-2 rounded-md">
          + 새 글 작성
        </Link>
      </div>
      <div className="bg-white rounded-xl shadow-card border border-medical-100 overflow-x-auto">
        <table className="w-full text-sm table-fixed min-w-[640px]">
          <colgroup>
            <col className="w-16" />
            <col />
            <col className="w-48" />
            <col className="w-36" />
          </colgroup>
          <thead className="bg-medical-50 text-medical-700">
            <tr>
              <th className="text-left px-3 py-2">번호</th>
              <th className="text-left px-3 py-2">제목</th>
              <th className="text-left px-3 py-2">작성자 / 소속</th>
              <th className="text-left px-3 py-2">작성일</th>
            </tr>
          </thead>
          <tbody>
            {posts.map(p => (
              <tr key={p.id} className="border-t border-medical-50 hover:bg-medical-50/40 align-top">
                <td className="px-3 py-2 text-medical-500">{p.id}</td>
                <td className="px-3 py-2">
                  <Link to={'/' + kind + '/' + p.id} className="font-medium text-medical-800 hover:underline break-all">
                    {p.title}
                  </Link>
                </td>
                <td className="px-3 py-2 break-keep">
                  <div className="text-medical-800">{p.author_name}</div>
                  <div className="text-[11px] text-medical-500">{p.author_institution}</div>
                </td>
                <td className="px-3 py-2 text-medical-700 text-xs leading-tight break-keep">{fmtDate(p.created_at)}</td>
              </tr>
            ))}
            {posts.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-medical-400">게시글이 없습니다.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
